// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2026 Ben Richardson — https://benrichardson.dev
// Additional terms under AGPL-3.0 section 7(b) apply; see ADDITIONAL-TERMS.md.
/** Small display formatters. Pure and unit-tested. */

/** Human-readable byte count, e.g. 1536 → "1.5 KB". */
export function fmtBytes(n: number): string {
  if (!Number.isFinite(n) || n < 0) return '—';
  if (n < 1024) return `${n} B`;
  const units = ['KB', 'MB', 'GB', 'TB'];
  let val = n / 1024;
  let i = 0;
  while (val >= 1024 && i < units.length - 1) {
    val /= 1024;
    i++;
  }
  return `${val < 10 ? val.toFixed(1) : Math.round(val)} ${units[i]}`;
}

/** "3 characters", "1 character". */
export function fmtChars(n: number): string {
  return `${n} character${n === 1 ? '' : 's'}`;
}

/** Two-digit clock time HH:MM:SS for a Date. */
export function fmtClock(d: Date): string {
  const p = (x: number) => x.toString().padStart(2, '0');
  return `${p(d.getHours())}:${p(d.getMinutes())}:${p(d.getSeconds())}`;
}
